<template>
  <div class="row">
    <form @submit.prevent="validate" novalidate>

      <div class="col-12 q-pa-md">
        <p class="text-weight-bold">
          {{ getString('requestReset.label') }}
        </p>
        <p class="light">
          {{ getString('requestReset.text') }}
        </p>
      </div>

      <div class="col-12 q-pa-md">
        <q-field>
          <q-input
            color="white"
            type="email"
            placeholder="Je e-mailadres"
            inverted-light
            v-model="email"
            class="no-shadow bg-grey-11"
          />
        </q-field>
      </div>

      <div class="no-padding message" :class="{ active: errorOpen }">
        <div class="row">
          <div class="col-12 q-pa-md">
            <div class="message-inner">
              <span class="text-weight-bold message-title">
                {{ getString('login.input.error.head') }}
              </span>
              <p class="message-body">
                {{ getString('login.input.error.message') }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="no-padding message success" :class="{ active: successOpen }">
        <div class="row">
          <div class="col-12 q-pa-md">
            <div class="message-inner">
              <span class="text-weight-bold message-title">
                {{ getString('requestReset.success.head') }}
              </span>
              <p class="message-body">
                {{ getString('requestReset.success.message') }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 q-pa-md">
          <q-btn
            align="right"
            color="primary"
            :label="getString('requestReset.button')"
            size="md"
            type="submit"
            class="float-right capitalize"
          />
      </div>
    </form>
  </div>
</template>


<script>
import qs from 'qs';
// Imports
import { required, email } from 'vuelidate/lib/validators';
import getString from '@/helpers/GetStrings';

export default {
  name: 'Reset',
  data() {
    return {
      email: '',
      errorOpen: false,
      successOpen: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    getString,
    validate() {
      // Validate
      this.$v.$touch();
      // Errors in form
      if (this.$v.$invalid) {
        this.errorOpen = true;
      // No errors in form
      } else {
        this.axios.post('reset', qs.stringify({ email: this.email }))
          .then(() => {
            // Hide loader
            this.$q.loading.hide();
            this.successOpen = true;
          })
          .catch((error) => {
            console.warn(error);
            this.$q.loading.hide();
            this.errorOpen = true;
          });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
.light
  color: $ctrl-grey-darken-3
  line-height 21px

.message
  width: calc(100% + 1rem);
  margin-left: -0.5rem;
  background-color: $ctrl-red;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease;
  &.success
    background-color: $ctrl-turquoise

  &.active
    max-height: 1000px;

.message-inner
  padding-left: 1rem;
  padding-right: 1rem;

.message-title
  color: rgba(0, 0, 0, 0.55);
  text-shadow: hsla(0, 0%, 100%, 0.1) 0 1px 0;
  margin-bottom: 0.5rem;
  display: inline-block;

.message-body
  color: rgba(0, 0, 0, 0.55);
  text-shadow: hsla(0, 0%, 100%, 0.1) 0 1px 0;
  margin-bottom: 0;
</style>
